module.exports = __webpack_public_path__ + "static/media/view6.c8eb010e.jpg";